import { createSlice } from '@reduxjs/toolkit';
import { AppThunk } from '../../../app/store';
import { getPolicyStatusEndPoint } from '../../../common/api.endPoints';
import { HttpService } from '../../../common/http.service';

const defaultState: {
  policyStatus: string | null;
  fetchPolicyStatusInProgress: boolean;
  fetchPolicyStatusError: boolean | null;
} = {
  policyStatus: null,
  fetchPolicyStatusInProgress: false,
  fetchPolicyStatusError: null,
};

export const policyStatusSlice = createSlice({
  name: 'policyStatus',

  initialState: defaultState,

  reducers: {
    onPolicyStatusFetchStart: state => {
      state.fetchPolicyStatusInProgress = true;
    },
    onPolicyStatusReceived: (state, action) => {
      state.fetchPolicyStatusInProgress = false;
      state.policyStatus = action.payload.policyStatus;
    },
    onPolicyStatusFetchFailed: state => {
      state.fetchPolicyStatusInProgress = false;
      state.fetchPolicyStatusError = true;
    },
    onPolicyStatusCleared: state => {
      state.policyStatus = defaultState.policyStatus;
      state.fetchPolicyStatusInProgress =
        defaultState.fetchPolicyStatusInProgress;
      state.fetchPolicyStatusError = defaultState.fetchPolicyStatusError;
    },
  },
});

export const getPolicyStatus =
  (applicationId: number): AppThunk =>
  async dispatch => {
    dispatch(policyStatusActions.onPolicyStatusFetchStart());

    const response = await HttpService.getInstance().get(
      getPolicyStatusEndPoint(applicationId),
    );

    if (response && !response.error) {
      dispatch(
        policyStatusActions.onPolicyStatusReceived({
          policyStatus: response?.parsedBody?.policyStatus,
        }),
      );
    } else {
      dispatch(policyStatusActions.onPolicyStatusFetchFailed());
    }
  };

export const clearPolicyStatus = (): AppThunk => async dispatch => {
  dispatch(policyStatusActions.onPolicyStatusCleared());
};

export const policyStatusReducer = policyStatusSlice.reducer;
export const policyStatusActions = policyStatusSlice.actions;
